export default __webpack_public_path__ + "static/tiles-4-ba2ba8ac3388209631dfdd7c102595b0.webp";